import React from 'react';
import PageList from '../../../components/PageListAPI'
import { deleteStorageUnit, getStorageUnit } from '../../../api/list'
import { useCan } from '../../../hooks/useCan';
import { SLUGS } from '../../../enum/permissions.enum';

export default function StorageUnit(props) {
  const can = useCan()
  const canUpdate = can(SLUGS.CATALOG.UPDATE)
  return (
    <div className='App-paper'>
      <PageList
        name='storageUnit'
        title='Единица измерения'
        columns={[{ id: 'code', name: 'Код' },{ id: 'name', name: 'Название' }]}
        createItem={can(SLUGS.CATALOG.CREATE)}
        deleteItem={can(SLUGS.CATALOG.DELETE)}
        loadAPI={{
          request: getStorageUnit,
        }}
        click={canUpdate}
        onClickFunction={canUpdate ? (row,obj)=>handleClick(row,obj,props.history) : undefined}
        disabledDelete={obj=>!!obj.code}
        deleteAPI={deleteStorageUnit}
        {...props}
      />
    </div>
  )
};

function handleClick(row,obj,history){
  if(!obj.code){
    history.push(`${history.location.pathname}/${obj.id}`)
  }
}